/* Heavy Hearts Club theme JS */
(() => {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const routes = (window.theme && window.theme.routes) || {};
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  /* ---------- Drawers / overlays ---------- */
  const overlay = $('[data-overlay]');
  let lastFocus = null;
  let cartBusy = false;

  function openPanel(id) {
    const el = document.getElementById(id);
    if (!el) return;
    closePanels(true);
    // Drawers must escape the sticky header's stacking context.
    if (el.parentElement !== document.body) document.body.appendChild(el);
    lastFocus = document.activeElement;
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    if (overlay) {
      overlay.hidden = false;
      void overlay.offsetWidth;
      overlay.classList.add('is-open');
    }
    document.body.classList.add('is-locked');
    const focusTarget = $('[data-search-input], [data-close], a, button, input', el);
    if (focusTarget) setTimeout(() => focusTarget.focus({ preventScroll: true }), 50);
  }

  function closePanels(immediate) {
    $$('.drawer.is-open, .search-overlay:not([hidden])').forEach((el) => {
      el.classList.remove('is-open');
      const hide = () => {
        if (!el.classList.contains('is-open') && !el.hasAttribute('data-filters')) el.hidden = true;
      };
      if (immediate || !el.classList.contains('drawer')) hide();
      else setTimeout(hide, 300);
    });
    if (overlay) {
      overlay.classList.remove('is-open');
      setTimeout(() => {
        if (!overlay.classList.contains('is-open')) overlay.hidden = true;
      }, 250);
    }
    document.body.classList.remove('is-locked');
    if (lastFocus && !immediate) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- Cart ---------- */
  function setCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  async function refreshCart() {
    const [sectionsRes, cartRes] = await Promise.all([
      fetch(`${routes.root}?sections=cart-drawer`),
      fetch(routes.cartJson),
    ]);
    const sections = await sectionsRes.json();
    const cart = await cartRes.json();
    if (!sectionsRes.ok || !cartRes.ok || !sections['cart-drawer']) throw new Error('Your bag could not refresh. Open View bag to check your items.');
    const drawer = $('#CartDrawer');
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = $('#CartDrawer', doc);
    if (drawer && fresh) drawer.innerHTML = fresh.innerHTML;
    setCartCount(cart.item_count);
    return cart;
  }

  async function changeLine(line, quantity) {
    if (cartBusy) return;
    cartBusy = true;
    const error = $('[data-cart-error]');
    if (error) error.hidden = true;
    const controls = $$('[data-cart-qty], [data-cart-input], [data-cart-remove]');
    controls.forEach((el) => { el.disabled = true; el.setAttribute('aria-disabled', 'true'); });
    try {
      const res = await fetch(`${routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.description || data.message || 'Could not update your bag. Please try again.');
      }
      if ($('[data-cart-page]')) {
        window.location.reload();
        return;
      }
      await refreshCart();
    } catch (err) {
      if (error) { error.textContent = err.message; error.hidden = false; }
    } finally {
      cartBusy = false;
      controls.forEach((el) => { el.disabled = false; el.removeAttribute('aria-disabled'); });
    }
  }

  async function addToCart(form) {
    const btn = $('[data-add-btn]', form);
    const label = $('[data-add-label]', form);
    const errorEl = $('[data-form-error]', form);
    const original = label ? label.textContent : '';
    if (errorEl) errorEl.hidden = true;
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    form.dataset.adding = 'true';
    if (label) label.textContent = 'Adding...';

    const body = new FormData(form);
    Array.from(body.keys())
      .filter((k) => k.startsWith('options['))
      .forEach((k) => body.delete(k));

    try {
      const res = await fetch(`${routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add to bag.');
      }
      if (window.theme.cartType === 'page') {
        window.location.href = routes.cart;
        return;
      }
      try { await refreshCart(); } catch (_) { window.location.href = routes.cart; return; }
      openPanel('CartDrawer');
    } catch (err) {
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }
    } finally {
      delete form.dataset.adding;
      form.dispatchEvent(new Event('cart:add-finished'));
      if (!form.closest('[data-product-section]')) { btn.disabled = false; if (label) label.textContent = original; }
    }
  }

  /* ---------- Gallery ---------- */
  class Gallery {
    constructor(root) {
      this.root = root;
      this.slides = $$('[data-slide]', root);
      try {
        const product=JSON.parse(root.closest('[data-product-section]').querySelector('[data-product-json]').textContent);
        const byId=new Map(product.variants.filter(v=>v.mediaId).map(v=>[String(v.mediaId),v.color]));
        const manifests={"15872515932326":{"pepper":6,"black":6,"white":8,"grey":8,"blossom":8,"berry":8},"15872711786662":{"pepper":6,"black":6,"white":8,"ivory":8,"grey":8,"true-navy":8},"15872682524838":{"pepper":6,"black":6,"white":8,"ivory":8,"grey":8,"blue-spruce":8,"chambray":8,"blue-jean":8,"blossom":8},"15872552239270":{"pepper":7,"black":7,"white":7,"ivory":7,"grey":7,"chambray":7,"blossom":7},"15870539727014":{"white":13,"ivory":13,"pepper":13,"grey":13,"bay":13,"blue-spruce":13,"seafoam":13,"chambray":13,"blue-jean":13,"true-navy":13,"black":13,"violet":13,"orchid":13,"blossom":13,"berry":13},"15872026214566":{"gold":4,"olive":3,"spruce":3,"royal":3,"navy":3,"black":2,"baby-pink":3,"heather-grey":3,"dark-grey":3,"red":3,"brown":3},"15872345178278":{"dark-green-natural":4,"royal-natural":4,"navy-natural":4,"white":4,"black":4,"black-natural":4,"red-natural":4}};
        const manifest=manifests[String(product.productId)];
        const colorOrder=manifest ? Object.keys(manifest) : [...byId.values()];
        const count=manifest ? colorOrder.length : byId.size,extra=this.slides.length-count;
        const fronts=this.slides.slice(0,count);
        const counts=colorOrder.map(color=>manifest ? manifest[color]-1 : extra/count);
        const purchasable=new Set(product.variants.map(v=>v.color));
        if(count>1 && extra>=count && counts.every(n=>Number.isInteger(n)&&n>=1) && counts.reduce((a,b)=>a+b,0)===extra && fronts.every((s,i)=>manifest ? (!byId.has(s.dataset.mediaId)||byId.get(s.dataset.mediaId)===colorOrder[i]) : byId.has(s.dataset.mediaId))){
          const ordered=[]; let offset=count;
          for(let i=0;i<count;i++){
            const front=this.slides[i],color=manifest ? colorOrder[i] : byId.get(front.dataset.mediaId);
            const group=[front,...this.slides.slice(offset,offset+counts[i])]; offset+=counts[i];
            group.forEach(s=>{s.dataset.color=color;if(!purchasable.has(color))s.dataset.unavailableColor="true";ordered.push(s);});
          }
          this.slides=ordered;
          ordered.forEach(s=>s.parentElement.append(s));
          const thumbs=$$('[data-thumb-item]',root);
          ordered.forEach(s=>{const thumb=thumbs.find(t=>t.dataset.mediaId===s.dataset.mediaId);if(thumb){thumb.dataset.color=s.dataset.color;thumb.parentElement.append(thumb);}});
        }
      } catch (_) {}
      this.thumbs = $$('[data-thumb-item]', root);
      this.counter = $('[data-counter]', root);
      this.color = null;
      this.allButton = $('[data-gallery-all]', root);
      if (this.allButton) this.allButton.addEventListener('click', () => this.setColor(null));

      this.thumbs.forEach((li) => {
        $('[data-thumb]', li).addEventListener('click', () => {
          const slide = this.slideById(li.dataset.mediaId);
          if (slide) this.show(slide, true);
        });
      });
      const prev = $('[data-prev]', root);
      const next = $('[data-next]', root);
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      const stage = $('[data-stage]', root);
      let startX = null;
      stage.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) this.step(dx < 0 ? 1 : -1);
      });
      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.step(-1);
        if (e.key === 'ArrowRight') this.step(1);
      });

      if (window.matchMedia('(hover: hover)').matches) {
        stage.addEventListener('click', (e) => {
          const img = e.target.closest('[data-zoom]');
          if (!img) return;
          const slide = img.closest('[data-slide]');
          slide.classList.toggle('is-zoomed');
          this.moveZoom(e, img);
        });
        stage.addEventListener('mousemove', (e) => {
          const img = $('.is-zoomed [data-zoom]', stage);
          if (img) this.moveZoom(e, img);
        });
        stage.addEventListener('mouseleave', () => {
          $$('.is-zoomed', stage).forEach((s) => s.classList.remove('is-zoomed'));
        });
      }
      this.updateCounter();
    }

    moveZoom(e, img) {
      const r = img.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    }

    slideById(id) {
      return this.slides.find((s) => s.dataset.mediaId === String(id));
    }

    visible() {
      return this.slides.filter((s) => !s.hidden);
    }

    current() {
      return this.slides.find((s) => s.classList.contains('is-active'));
    }

    step(dir) {
      const list = this.visible();
      if (list.length < 2) return;
      const i = list.indexOf(this.current());
      this.show(list[(i + dir + list.length) % list.length], true);
    }

    show(slide, syncSelection = false) {
      this.slides.forEach((s) => {
        s.classList.remove('is-zoomed');
        if (s !== slide) {
          s.classList.remove('is-active');
          const v = $('video', s);
          if (v) v.pause();
        }
      });
      slide.classList.add('is-active');
      this.thumbs.forEach((li) => {
        const active = li.dataset.mediaId === slide.dataset.mediaId;
        $('[data-thumb]', li).classList.toggle('is-active', active);
        if (active && !li.hidden) {
          const strip = li.parentElement;
          if (strip.scrollWidth > strip.clientWidth) {
            const left = li.offsetLeft - strip.offsetLeft;
            if (left < strip.scrollLeft) strip.scrollLeft = left;
            else if (left + li.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + li.offsetWidth - strip.clientWidth;
          }
          if (strip.scrollHeight > strip.clientHeight) {
            const top = li.offsetTop - strip.offsetTop;
            if (top < strip.scrollTop) strip.scrollTop = top;
            else if (top + li.offsetHeight > strip.scrollTop + strip.clientHeight) strip.scrollTop = top + li.offsetHeight - strip.clientHeight;
          }
        }
      });
      this.updateCounter();
      if (syncSelection) this.root.dispatchEvent(new CustomEvent('gallery:media-change', { bubbles: true, detail: { mediaId: slide.dataset.mediaId } }));
      if (syncSelection && slide.dataset.color && slide.dataset.color !== 'all') {
        this.root.dispatchEvent(new CustomEvent('gallery:color-change', { bubbles: true, detail: { color: slide.dataset.color } }));
      }
    }

    updateCounter() {
      if (!this.counter) return;
      const list = this.visible();
      const i = list.indexOf(this.current());
      this.counter.textContent = list.length > 1 ? `${i + 1} / ${list.length}` : '';
      this.counter.hidden = list.length < 2;
    }

    // Show only the media that belongs to this color (plus shared "all" media).
    // If a color has no tagged media at all, everything stays visible.
    setColor(color, mediaId) {
      const matches = (slide) => slide.dataset.unavailableColor !== "true";
      this.slides.forEach((s) => { s.hidden = !matches(s); });
      this.thumbs.forEach((li) => { li.hidden = !matches(li); });
      this.color = color;
      if (this.allButton) this.allButton.setAttribute('aria-pressed', String(!color));
      const target = (mediaId && this.visible().find((s) => s.dataset.mediaId === String(mediaId))) || this.visible()[0];
      if (target) this.show(target);
    }
  }

  /* ---------- Product ---------- */
  class Product {
    constructor(root) {
      this.root = root;
      this.data = JSON.parse($('[data-product-json]', root).textContent);
      this.form = $('[data-product-form]', root);
      this.options = $$('[data-option]', root);
      // Keep future imported model and size choices in a readable order.
      this.options.forEach((field) => {
        const wrap = $('.opt__values', field);
        if (!wrap) return;
        const values = $$('[data-option-value]', wrap);
        const rank = (text) => {
          const s = text.toLowerCase();
          const phone = s.match(/iphone\s*(\d+)/);
          if (phone) return [0, Number(phone[1]), /pro\s*max/.test(s) ? 5 : /pro/.test(s) ? 4 : /plus/.test(s) ? 3 : /air/.test(s) ? 2 : /\de\b|\d e\b/.test(s) ? 1 : 0];
          const family = /baby|romper/.test(s) ? 0 : /kid|^\d.*y\b/.test(s) ? 1 : /mom|mother|women/.test(s) ? 2 : /dad|father|men/.test(s) ? 3 : /dog|pet/.test(s) ? 4 : /hat/.test(s) ? 5 : 0;
          const size = s.match(/(?:^|\s|-)(xs|s|m|l|xl|xxl|xxxl|[2-5]xl)(?:\b|\()/);
          const ranks = {xs:0,s:1,m:2,l:3,xl:4,xxl:5,xxxl:6,'2xl':5,'3xl':6,'4xl':7,'5xl':8};
          const number = size ? ranks[size[1]] : Number((s.match(/\d+/) || [0])[0]);
          return [1, family, number];
        };
        const items = values.map(input => ({input, label: Array.from(wrap.querySelectorAll('label')).find(label => label.htmlFor === input.id)}));
        items.sort((a, b) => {
          if (!field.hasAttribute('data-color-option')) {
            const x = rank(a.input.value), y = rank(b.input.value);
            for (let i = 0; i < Math.max(x.length, y.length); i++) {
              const delta = (x[i] || 0) - (y[i] || 0);
              if (delta) return delta;
            }
          }
          return a.input.value.localeCompare(b.input.value, undefined, {numeric:true, sensitivity:'base'});
        });
        items.forEach(({input,label}) => { wrap.append(input); if (label) wrap.append(label); });
      });
      this.gallery = new Gallery($('[data-gallery]', root));
      this.idInput = $('[data-variant-id]', root);
      this.variant = this.data.variants.find((v) => String(v.id) === this.idInput.value) || this.data.variants[0];
      this.color = null;
      root.addEventListener('gallery:media-change', (event) => {
        const styleIndex = this.data.colorIndex >= 0 ? this.data.colorIndex : this.options.findIndex(field => /options\[(?:Color Choice|Design|Bundle)\]/i.test($('[data-option-value]', field)?.name || ''));
        if (styleIndex < 0) return;
        const selection = this.selected();
        const matches = this.data.variants.filter(v => String(v.mediaId) === String(event.detail.mediaId));
        const match = matches.find(v => v.options.every((value, i) => i === styleIndex || value === selection[i])) || matches[0];
        if (!match) return;
        const input = $$('[data-option-value]', this.options[styleIndex]).find(input => input.value === match.options[styleIndex]);
        if (input) { input.checked = true; this.update(false); }
      });
      root.addEventListener('gallery:color-change', (event) => {
        const match = this.data.variants.find(v => v.color === event.detail.color);
        const field = this.options[this.data.colorIndex];
        if (!match || !field) return;
        const input = $$('[data-option-value]', field).find(i => i.value === match.options[this.data.colorIndex]);
        if (input) { input.checked = true; this.color = match.color; this.update(false); }
      });

      this.form.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-value]')) this.update(!!e.target.closest('[data-color-option]'));
      });
      this.form.addEventListener('click', (e) => {
        if (e.target.matches('[data-color-option] [data-option-value]')) this.update(true);
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (!$('[data-add-btn]', this.form).disabled) addToCart(this.form);
      });
      this.form.addEventListener('cart:add-finished', () => this.update());
      $$('[data-qty-step]', root).forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = $('[data-qty-input]', root);
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qtyStep));
        });
      });
      const share = $('[data-share]', root);
      if (share) {
        share.addEventListener('click', async () => {
          const { url, title } = share.dataset;
          if (navigator.share) {
            try { await navigator.share({ title, url }); } catch (_) { /* cancelled */ }
          } else if (navigator.clipboard) {
            await navigator.clipboard.writeText(url);
            share.textContent = 'Link copied';
          }
        });
      }
      this.refreshAvailability();
      this.update(true);

    }

    selected() {
      return this.options.map((fs) => {
        const checked = $('[data-option-value]:checked', fs);
        return checked ? checked.value : undefined;
      });
    }

    matches(variant, selection) {
      return selection.every((val, i) => val === undefined || variant.options[i] === val);
    }

    refreshAvailability() {
      const selection = this.selected();
      this.options.forEach((fs, i) => {
        $$('[data-option-value]', fs).forEach((input) => {
          const candidate = selection.slice();
          candidate[i] = input.value;
          const ok = this.data.variants.some((v) => v.available && this.matches(v, candidate));
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    update(filterColor = false) {
      const selection = this.selected();
      this.options.forEach((fs, i) => {
        const label = $('[data-option-label]', fs);
        if (label) label.textContent = selection[i] || '';
      });
      this.refreshAvailability();

      const variant = this.data.variants.find((v) => this.matches(v, selection));
      const btn = $('[data-add-btn]', this.form);
      const label = $('[data-add-label]', this.form);

      if (filterColor && this.data.colorIndex >= 0) {
        const selectedColor = selection[this.data.colorIndex];
        const colorVariant = this.data.variants.find((v) => v.options[this.data.colorIndex] === selectedColor);
        if (colorVariant) {
          this.color = colorVariant.color;
          this.gallery.setColor(colorVariant.color, (variant || colorVariant).mediaId);
        }
      }
      if (!variant) {
        const styleIndex = this.data.colorIndex >= 0 ? this.data.colorIndex : this.options.findIndex(field => /options\[(?:Color Choice|Design|Bundle)\]/i.test($('[data-option-value]', field)?.name || ''));
        const styleVariant = styleIndex >= 0 && this.data.variants.find(v => v.options[styleIndex] === selection[styleIndex] && v.mediaId);
        if (styleVariant) this.gallery.setColor(styleVariant.color || null, styleVariant.mediaId);
        this.variant = null;
        this.idInput.value = '';
        btn.disabled = true;
        if (label) label.textContent = 'Unavailable';
        return;
      }
      this.variant = variant;
      this.idInput.value = variant.id;
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      const current = $('[data-price-current]', this.root);
      const compare = $('[data-price-compare]', this.root);
      if (current) current.textContent = variant.price;
      if (compare) {
        compare.textContent = variant.compare;
        compare.hidden = !variant.onSale;
      }
      const priceWrap = $('.price', this.root);
      if (priceWrap) priceWrap.classList.toggle('price--sale', variant.onSale);

      btn.disabled = !variant.available || this.form.dataset.adding === 'true';
      if (label) label.textContent = this.form.dataset.adding === 'true' ? 'Adding...' : variant.available ? 'Add to cart' : 'Sold out';

      if (variant.mediaId) {
        this.gallery.setColor(variant.color || null, variant.mediaId);
      }
    }
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openPanel(opener.dataset.open);
      return;
    }
    if (e.target.closest('[data-close]') || e.target === overlay) {
      closePanels();
      return;
    }

    const trigger = e.target.closest('[data-cart-trigger]');
    if (trigger && window.theme.cartType === 'drawer' && !$('[data-cart-page]')) {
      e.preventDefault();
      openPanel('CartDrawer');
      return;
    }

    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      if (cartBusy) return;
      const input = $('[data-cart-input]', qtyBtn.closest('[data-qty]'));
      changeLine(qtyBtn.dataset.line, Math.max(0, Number(input.value) + Number(qtyBtn.dataset.cartQty)));
      return;
    }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      if (cartBusy) return;
      changeLine(remove.dataset.line, 0);
      return;
    }

    const swatch = e.target.closest('[data-card-swatch]');
    if (swatch) {
      e.preventDefault();
      const card = swatch.closest('[data-card]');
      const img = $('[data-card-image]', card);
      if (swatch.dataset.image && img) {
        img.removeAttribute('srcset');
        img.src = swatch.dataset.image;
        img.alt = swatch.getAttribute('aria-label') || '';
        const hover = $('.card__img--hover', card);
        if (hover) { hover.removeAttribute('srcset'); hover.src = swatch.dataset.image; }
        card.classList.add('is-swatched');
      }
      if (swatch.dataset.href) $$('[data-card-link]', card).forEach((a) => { a.href = swatch.dataset.href; });
      $$('[data-card-swatch]', card).forEach((s) => s.classList.toggle('is-active', s === swatch));
      return;
    }

    const recover = e.target.closest('[data-recover-toggle]');
    if (recover) {
      e.preventDefault();
      $('#recover').hidden = false;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closePanels();
    if (e.key === 'Tab') {
      const panel = $('.drawer.is-open, .search-overlay.is-open');
      if (!panel) return;
      const focusable = $$('a[href], button, input, select, textarea, [tabindex="0"]', panel).filter((el) => !el.disabled && el.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first) return;
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-cart-input]')) {
      changeLine(e.target.dataset.line, Math.max(0, Number(e.target.value) || 0));
    }
    if (e.target.closest('[data-sort-form]')) e.target.closest('form').submit();
  });

  const submitFilters = debounce((form) => {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (value !== '') params.append(key, value);
    });
    window.location.search = params.toString();
  }, 400);

  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-filter-form]');
    if (form) submitFilters(form);
  });

  document.addEventListener('submit', (e) => {
    const confirmMsg = e.target.dataset && e.target.dataset.confirm;
    if (confirmMsg && !window.confirm(confirmMsg)) e.preventDefault();
  });

  /* ---------- Init ---------- */
  function initProducts(root = document) {
    const products = root.matches && root.matches('[data-product-section]') ? [root] : $$('[data-product-section]', root);
    products.forEach((el) => { if (!el.dataset.initialized) { new Product(el); el.dataset.initialized = 'true'; } });
  }
  document.addEventListener('shopify:section:load', (event) => initProducts(event.target));
  document.addEventListener('DOMContentLoaded', () => {
    initProducts();

    // Announcement rotator
    const items = $$('.announcement__item');
    if (items.length > 1) {
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4500);
    }

    // Predictive search
    const input = $('[data-search-input]');
    const results = $('[data-search-results]');
    if (input && results && routes.predictiveSearch) {
      let controller;
      input.addEventListener('input', debounce(async () => {
        const q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        if (controller) controller.abort();
        controller = new AbortController();
        try {
          const res = await fetch(
            `${routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`,
            { signal: controller.signal }
          );
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const section = $('#shopify-section-predictive-search', doc);
          results.innerHTML = section ? section.innerHTML : '';
        } catch (err) {
          if (err.name !== 'AbortError') results.innerHTML = '';
        }
      }, 250));
    }

    // Product recommendations
    $$('[data-recommendations]').forEach(async (el) => {
      try {
        const res = await fetch(el.dataset.url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      } catch (_) { /* leave empty */ }
    });

    // Address country default
    $$('select[data-default]').forEach((s) => {
      if (s.dataset.default) s.value = s.dataset.default;
    });

    if (window.location.hash === '#recover' && $('#recover')) $('#recover').hidden = false;
  });
})();

(() => {
  const colors={black:'#1F1F1F',white:'#FFFFFF',natural:'#EAE5D2',navy:'#202944',royal:'#304797',red:'#C71935',cream:'#F3EBD7',ivory:'#F4EDDD',grey:'#848786',gray:'#848786',charcoal:'#383838',brown:'#674838',tan:'#C5A37B',olive:'#646747','dark green':'#294C3B',green:'#3C6550',pink:'#E7BBCB',purple:'#79629C',gold:'#CF9F29',orange:'#D86D30',yellow:'#E6C54C',blue:'#537DA7','blue jean':'#7B8695','blue spruce':'#576D61',chambray:'#D8EBF5',seafoam:'#65A49E',orchid:'#E2C3DB',violet:'#988AD1',blossom:'#EFC8CC',berry:'#7B4E67',bay:'#A8B4A3',pepper:'#585955','true navy':'#242337',spruce:'#32584B','dark grey':'#484548','baby pink':'#EDC1D3',burgundy:'#682B3B',maroon:'#682B3B',hunter:'#244B3B','tropical pink':'#EE5596','heather grey':'#B9B9B7','charcoal heather':'#454545',sandshell:'#ECE3D3','oatmeal heather':'#E8E5D9','army green':'#555B36','sports green':'#264D43','blue mist':'#BED0D5','royal blue':'#164FC9','pale pink':'#EFC6B2',lilac:'#DCD2E8','neon pink':'#E97EB6','neon green':'#88C51D','neon yellow':'#DDDF4D','neon orange':'#EF803B','neon blue':'#119BC4'};
  const norm=s=>String(s||'').trim().toLowerCase().replace(/\s+/g,' ');
  function init(root=document){
    root.querySelectorAll('[data-color-option] label,[data-card-swatch]').forEach(el=>{
      const input=el.htmlFor&&document.getElementById(el.htmlFor);
      const name=norm(input?input.value:el.title||el.getAttribute('aria-label'));
      const shades=name.split(/\s*\/\s*|\s+&\s+/).map(p=>colors[p]||(CSS.supports('color',p)?p:null)||Object.keys(colors).sort((a,b)=>b.length-a.length).filter(k=>p.endsWith(' '+k)).map(k=>colors[k])[0]||'#848786');
      el.style.removeProperty('background-image');
      el.style.setProperty('--swatch',shades.length>1?'linear-gradient(90deg,'+shades.map((c,i)=>c+' '+i*100/shades.length+'%,'+c+' '+(i+1)*100/shades.length+'%').join(',')+')':shades[0]);
    });
    root.querySelectorAll('[data-announcement]').forEach(bar=>{
      if(bar.dataset.tickerReady)return;
      const track=bar.querySelector('.announcement__track');
      const items=[...bar.querySelectorAll('.announcement__item')];
      if(!track||!items.length)return;
      bar.dataset.tickerReady='true';bar.classList.add('hh-promo');
      const group=document.createElement('div');group.className='hh-promo__group';
      items.forEach(item=>group.append(item));
      for(let i=1;i<3;i++)items.forEach(item=>{const copy=item.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.querySelectorAll('a').forEach(a=>a.tabIndex=-1);group.append(copy);});
      track.replaceChildren(group);
      const duplicate=group.cloneNode(true);duplicate.setAttribute('aria-hidden','true');duplicate.querySelectorAll('a').forEach(a=>a.tabIndex=-1);track.append(duplicate);
    });
  }
  const style=document.createElement('style');
  style.textContent='.hh-promo{height:36px!important;background:#111!important;color:#fff!important;overflow:hidden;padding-right:0;font-size:12px;letter-spacing:.04em}.hh-promo .announcement__track{display:flex;width:max-content;height:36px;animation:hh-promo-scroll 42s linear infinite;will-change:transform}.hh-promo__group{display:flex;align-items:center;flex:0 0 auto}.hh-promo .announcement__item{position:static!important;inset:auto!important;opacity:1!important;flex:0 0 auto;white-space:nowrap;margin:0;padding:0 30px;display:flex;align-items:center;height:36px;transition:none!important}.hh-promo .announcement__item:after{content:"✦";margin-left:60px;color:#cfb580}.hh-promo__pause{position:absolute;right:0;top:0;width:40px;height:36px;border:0;border-left:1px solid #666;background:#111;color:#fff;cursor:pointer}.hh-promo__pause:focus-visible{outline:2px solid #fff;outline-offset:-3px}@keyframes hh-promo-scroll{to{transform:translateX(-50%)}}@media(prefers-reduced-motion:reduce){.hh-promo .announcement__track{animation-duration:70s}.hh-promo__pause{display:block}}';
  document.head.append(style);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1&&(node.matches?.('[data-card]')||node.querySelector?.('[data-card]')))init(node);}).observe(document.body,{childList:true,subtree:true});
})();

(() => {
  function setup(root) {
    root.querySelectorAll('[data-campaign-hero]').forEach(function(hero) {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      var slides = Array.from(hero.querySelectorAll('[data-campaign-slide]'));
      if (slides.length < 2) return;
      var index = 0, timer = null, touchX = null;
      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function(slide, i) { slide.hidden = i !== index; });
      }
      function stop() { clearInterval(timer); timer = null; }
      function start() {
        stop();
        if (!document.hidden) timer = setInterval(function() {
          var next = (index + 1) % slides.length;
          var image = slides[next].querySelector('img');
          if (!image || (image.complete && image.naturalWidth)) show(next);
        }, 4500);
      }
      hero.addEventListener('touchstart', function(event) { touchX = event.changedTouches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function(event) {
        if (touchX === null) return;
        var distance = event.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(distance) > 50) { show(index + (distance < 0 ? 1 : -1)); start(); }
      }, { passive: true });
      slides.forEach(function(slide) { var image=slide.querySelector('img'); if (image) image.loading='eager'; });
      document.addEventListener('visibilitychange', start);
      window.addEventListener('pageshow', start);
      document.addEventListener('shopify:section:unload', function(event) { if (event.target.contains(hero)) stop(); });
      show(0); start();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { setup(document); });
  else setup(document);
  document.addEventListener('shopify:section:load', function(event) { setup(event.target); });
})();
